/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    CantSeePolicy: {
        id: 'cep.LandingPage.CantSeePolicy',
        defaultMessage: 'Can\'t see your policy?'
    },
    AfterPurchasing: {
        id: 'cep.LandingPage.AfterPurchasing',
        defaultMessage: 'After purchasing a policy, it may take a few minutes to appear. Some policies can\'t be managed here, but you can view them in the Your insurance overview section of MySaga.'
    },
    YourInsuranceOverview: {
        id: 'cep.LandingPage.YourInsuranceOverview',
        defaultMessage: 'Your insurance overview'
    },
    WantToMakeClaim: {
        id: 'cep.LandingPage.WantToMakeClaim',
        defaultMessage: 'Want to make a claim?'
    },
    ReadHowToMakeClaim: {
        id: 'cep.LandingPage.ReadHowToMakeClaim',
        defaultMessage: 'Read how to make a claim'
    }
});
